import React from 'react';
import {ReactChildren} from '../../../types/types';
import {isPRD} from '../../../utlis/vars';
import {FmComponent} from '../types/types';
import './style.scss';

interface IContainer extends FmComponent {
  children: ReactChildren;
  style?: React.CSSProperties;
}

const Container = ({children, 'data-testid': dataTestId, id, className, style}: IContainer): React.ReactElement => {
  return (
    <div
      id={id}
      className={`fm-container${className ? ` ${className}` : ''}`}
      data-testid={isPRD ? undefined : dataTestId}
      style={style}
    >
      {children}
    </div>
  );
};

export default Container;
